<template>
  <div class="tw-flex tw-gap-2">
    <svg-vue
      class="'tw-w-5 tw-h-5 tw-shrink-0 tw-text-neutral"
      icon="icons/tag"
    />
    <span class="tw-text-sm tw-text-neutral-700">
      <slot />
    </span>
  </div>
</template>
